// FedEx-FedEx运费包裹数据对比

import { HttpHttPackageList, HttpPackageExport } from '@/service/fedex';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 100,
            },
        };
    },
    methods: {
        ajaxRequest: HttpHttPackageList,
        handleOperates(params = "", type, batch) {
            // if (batch === true) {
            //     params = (params || this.checkedData.join(",")) + "";
            //     if (!params.length) return this.$VMessage.warning("请选择至少一条数据");
            // }
            switch (type) {
                case "export":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + '/api/v2/packageComparison/export',
                        this.formData,
                        { executor: 'request', download: true, method: 'get' }
                    );
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getOrgList', 'getBillcusWareList', 'getProductList','getCarrierServiceList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export',{defaultValue:'导出'}),
                    operate: "export",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'}),
                    key: 'EQ_orgWarehouseCode',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusWareList.map(item => {
                        return {
                            value: item.attach.code,
                            label: item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "Tracking NO",
                    key: 'EQ_trackingNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                    key: 'EQ_invoiceNo',
                    show: true,
                    tag: 'vInput',
                },
                
                {
                    label: this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'}),
                    key: 'EQ_orderNo',
                    tag: 'vInput',
                },
                {
                    label: this.$t('bi.work.task_org_id',{defaultValue:'组织'}),
                    tag: 'vSelect',
                    key: 'EQ_orgId',
                    more: true,
                    options: this.getOrgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    tag: 'vSelect',
                    key: 'EQ_carrierCode',
                    more: true,
                    options: [
                        {value:'FedEx',label:'FedEx'},
                        {value:'UPS',label:'UPS'},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.analyze.weightError',{defaultValue:'计费重异常标记'}),
                    tag: 'vSelect',
                    key: 'EQ_weightError',
                    more: true,
                    options: [
                        {value:1,label:this.$t('erp.global.yes',{defaultValue:'是'})},
                        {value:0,label:this.$t('erp.global.no',{defaultValue:'否'})},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.analyze.zoneCodeError',{defaultValue:'分区异常标记'}),
                    tag: 'vSelect',
                    key: 'EQ_zoneCodeError',
                    more: true,
                    options: [
                        {value:1,label:this.$t('erp.global.yes',{defaultValue:'是'})},
                        {value:0,label:this.$t('erp.global.no',{defaultValue:'否'})},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.bill.freeze_createdat',{defaultValue:'创建日期'}),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                    style: "width:250px",
                },
            ]
        },
        columns() {
            return [
                {
                    title: 'Tracking NO',
                    key: 'trackingNo',
                }, 
                {
                    title: this.$t('erp.b2border.invoice',{defaultValue:'发票号'})+'/'+this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'})+'/'+this.$t('bi.work.task_org_id',{defaultValue:'组织'})+'/'+this.$t('global.common.project',{defaultValue:'项目'}),
                    key: 'invoiceNo',
                    render:(h,{row}) =>{
                        const label = this.getProductList.find(function (item) {
							return item.value == row.lineId
                        }) || {};
                        const orgname = this.getOrgList.find(function (item) {
                            // console.log(item)
							return item.value == row.orgId
                        }) || {};
                        // console.log(orgname)
                        return <div>
                            <div>{row.invoiceNo || '--'}</div>
                            <div>{row.orderNo || '--'}</div>
                            <div>{orgname.label || '--'}</div>
                            <div>{label.label || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'})+'/'+this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'})+'/'+this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        let orgWarehouse = this.getBillcusWareList.find(item => {
                            return item.attach.code == orgWarehouseCode
                        })
                        // return <div>{orgWarehouse ? orgWarehouse.label : '--'}</div>
                        return <div>
                            <div>{row.orgWarehouseCode}</div>
                            <div>{row.carrierCode}</div>
                            <div>{row.carrierServiceCode}</div>
                        </div>
                    }
                }, {
                    title: this.$t('fbb.analyze.fedexsize',{defaultValue:'FedEx账单尺寸'})+'（inch）/'+this.$t('fbb.analyze.warehousesize',{defaultValue:'仓库尺寸'})+'（inch）',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.fedexLength} * {row.fedexWidth} * {row.fedexHeight}</div>
                            <div>{row.warehouseLength} * {row.warehouseWidth} * {row.warehouseHeight}</div>
                        </div>
                    }

                }, {
                    title: this.$t('fbb.analyze.fedexVolume',{defaultValue:'FedEx账单体积'})+'（cu in）/'+this.$t('fbb.analyze.warehouseVolume',{defaultValue:'仓库体积'})+'（cu in）/'+this.$t('fbb.analyze.diffVolume',{defaultValue:'体积差'}),
                    key: 'fedexVolume',
                    render: (h, { row }) => {
                        const val = row.volumeDifference
                        return <div>
                            <div>{row.fedexVolume}</div>
                            <div>{row.warehouseVolume}</div>
                            <div class='color-error' v-show={val < 0}>{val}</div > 
                            <div class='color-success' v-show={val >= 0}> {val}</div>
                        </div>
                    }
                }, 
                {
                    title: this.$t('fbb.analyze.systemWeight',{defaultValue:'系统计费重'})+'/'+this.$t('fbb.analyze.billWeight',{defaultValue:'账单计费重'})+'/'+this.$t('fbb.analyze.weightDifference',{defaultValue:'计费重差额'}),
                    // key: 'createdAt',
                    render:(h,{row})=>{
                        return <div>
                            <div>{row.systemWeight}</div>
                            <div>{row.billWeight}</div>
                            <div>{row.weightDifference}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.analyze.weightError',{defaultValue:'计费重异常标记'}),
                    // key: 'createdAt',
                    render:(h,{row})=>{
                        switch(row.weightError){
                            case 1: return this.$t('erp.global.yes',{defaultValue:'是'}); break;
                            case 0: return this.$t('erp.global.no',{defaultValue:'否'}); break;
                        }
                    }
                },
                {
                    title: this.$t('fbb.analyze.systemZoneCode',{defaultValue:'系统分区'})+'/'+this.$t('fbb.analyze.billZoneCode',{defaultValue:'账单分区'})+'/'+this.$t('fbb.analyze.zoneCodeDifference',{defaultValue:'分区差额'}),
                    // key: 'createdAt',
                    render:(h,{row})=>{
                        return <div>
                            <div>{row.systemZoneCode}</div>
                            <div>{row.billZoneCode}</div>
                            <div>{row.zoneCodeDifference}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.analyze.zoneCodeError',{defaultValue:'分区异常标记'}),
                    // key: 'createdAt',
                    render:(h,{row})=>{
                        switch(row.zoneCodeError){
                            case 1: return this.$t('erp.global.yes',{defaultValue:'是'}); break;
                            case 0: return this.$t('erp.global.no',{defaultValue:'否'}); break;
                        }
                    }
                },
                {
                    title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    key: 'createdAt',
                }
            ];
        },
    },
};




